// import axios from "axios";
// import {
//   CART_ADD_ITEM,
//   CART_REMOVE_ITEM,
//   CART_SAVE_PAYMENT_METHOD,
//   CART_SAVE_SHIPPING_ADDRESS,
// } from "../constants/cartConstants";
// import { serverIp } from "../config/conf";

// export const addToCart = (obj) => async (dispatch, getState) => {
//   // const { data } = await axios.get(`${serverIp}/api/products/${id}`);

//   // {
//   //   name: product.name,
//   //   image:
//   //     product.variants?.length > 0 &&
//   //     product.variants?.filter(
//   //       (variant) => variant._id === variantId
//   //     )[0]?.images[0],
//   //   qty,
//   //   sizeMen: "0",
//   //   sizeWomen: `${selectedSize}`,
//   //   price: product.price,
//   //   product: product._id,
//   //   variant: variantId,
//   //   sku: product.sku,
//   //   giftWrap: false,
//   //   message: "",
//   //   engraveMen: "",
//   //   engraveWomen: engravingText,
//   // }

//   const cartItem = {
//     productId: obj.product,
//     variantId: obj.variant,
//     qty: obj.qty,
//     sizeMen: obj.sizeMen,
//     sizeWomen: obj.sizeWomen,
//     giftWrap: obj.giftWrap,
//     message: obj.message,
//     engraveMen: obj.engraveMen,
//     engraveWomen: obj.engraveWomen,
//   };

//   const {
//     userLogin: { userInfo },
//   } = getState();

//   userInfo &&
//     (await axios.post(`${serverIp}/api/wishlist`, cartItem, {
//       headers: {
//         Authorization: `Bearer ${userInfo.token}`,
//       },
//     }));

//   dispatch({
//     type: CART_ADD_ITEM,
//     payload: cartItem,
//   });

//   localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
// };

// export const removeFromCart =
//   (id, size, userResponses) => async (dispatch, getState) => {
//     const {
//       userLogin: { userInfo },
//     } = getState();

//     userInfo &&
//       (await axios.post(
//         `${serverIp}/api/users/removeFromCart/${id}?size=${size}`,
//         { userResponses },
//         {
//           headers: {
//             Authorization: `Bearer ${userInfo.token}`,
//           },
//         }
//       ));

//     dispatch({ type: CART_REMOVE_ITEM, payload: { id, size, userResponses } });

//     localStorage.setItem(
//       "cartItems",
//       JSON.stringify(getState().cart.cartItems)
//     );
//   };

// export const saveShippingAddress = (data) => (dispatch) => {
//   dispatch({ type: CART_SAVE_SHIPPING_ADDRESS, payload: data });

//   localStorage.setItem("shippingAddress", JSON.stringify(data));
// };

// export const savePaymentMethod = (data) => (dispatch) => {
//   dispatch({ type: CART_SAVE_PAYMENT_METHOD, payload: data });

//   localStorage.setItem("paymentMethod", JSON.stringify(data));
// };

// src/actions/cartActions.js
import axios from "axios";
import {
  WISHLIST_ADD_ITEM,
  WISHLIST_REMOVE_ITEM,
  WISHLIST_CLEAR_ITEMS,
} from "../constants/wishListConstants";
import { serverIp } from "../config/conf";

export const getWishlistItems = () => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${serverIp}/api/wishlist`, config);
    dispatch({
      type: WISHLIST_ADD_ITEM,
      payload: data.wishlist.items,
    });
    localStorage.setItem(
      "wishlistItems",
      JSON.stringify(getState().wishlist.wishlistItems)
    );
  } catch (error) {
    console.error("Error fetching wishlist items:", error);
  }
};

export const addItemToWishlist = (productId) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${serverIp}/api/wishlist`,
      {
        productId,
      },
      config
    );

    dispatch({
      type: WISHLIST_ADD_ITEM,
      payload: data.wishlist.items,
    });

    localStorage.setItem(
      "wishlistItems",
      JSON.stringify(getState().wishlist.wishlistItems)
    );
  } catch (error) {
    console.error("Error adding item to wishlist:", error);
  }
};

export const removeItemFromWishlist =
  (productId) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.delete(
        `${serverIp}/api/wishlist/${productId}`,
        config
      );

      dispatch({
        type: WISHLIST_REMOVE_ITEM,
        payload: data.wishlist.items,
      });

      localStorage.setItem(
        "wishlistItems",
        JSON.stringify(getState().wishlist.wishlistItems)
      );
    } catch (error) {
      console.error("Error removing item from wishlist:", error);
    }
  };
